








import Vue from 'vue';

export default Vue.extend({
  name: 'App',
  computed: {
    userLoading(): boolean {
      return this.$auth.loading;
    },
    userIsAuthenticated(): boolean {
      return this.$auth.isAuthenticated;
    }
  },
  watch: {
    userLoading: {
      immediate: true,
      handler(value: boolean) {
        if (!value && this.userIsAuthenticated) {
          this.$store.direct.commit.User.UPDATE_USER(this.$auth.user);
        }
      }
    }
  }
});
